import superagent from "superagent";
import Cookies from "universal-cookie";
import { IS_LOADING, THROW_ERROR, THROW_SUCCESS } from "../store/constants";
import { base_url } from "./constants";
import { toast } from "react-toastify";

const cookie = new Cookies();

export function postRequest(url, data, dispatch, type = null, cookie_option = null, history = null, slug = null, actions = null) {
  dispatch({ type: IS_LOADING, payload: true });
  return superagent
    .post(`${base_url}${url}`)
    .send(data)
    .set("accept", "application/json")
    .set("Authorization", cookie.get("user_token"))
    .end((err, res) => {
      if (res) {
        if (res.body.status) {
          dispatch({ type: THROW_SUCCESS, payload: res.body.message });
          if (cookie_option === "save") {
            const token = `Bearer ${res.body.data.access_token}`;
            const user_info = res.body.data.user_data;
            cookie.set("user_token", token, { path: "/" });
            cookie.set("user_info", user_info);
          } else if (cookie_option === "delete") {
            cookie.remove("user_token");
          }
          if (history) {
            history.push(slug);
          }
          if (actions) {
            actions.resetForm({});
          }
        } else {
          dispatch({ type: THROW_ERROR, payload: res.body.message });
        }
        if (type != null) {
          dispatch({ type, payload: res.body.data });
        }
        dispatch({ type: IS_LOADING, payload: false });

        if (res.body.reload) {
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        }
      } else {
        dispatch({ type: THROW_ERROR, payload: err.data.message });
        dispatch({ type: IS_LOADING, payload: false });
      }
    });
}

export function getRequest(url, data, dispatch, type = null, setLoader = null, cookie_option = null, arrayOfCallbacks) {
  dispatch({ type: IS_LOADING, payload: true });
  return superagent
    .get(`${base_url}${url}`)
    .query(data)
    .set("accept", "application/json")
    .set("Authorization", cookie.get("user_token"))
    .end((_err, res) => {
      setLoader?.(false);
      if (arrayOfCallbacks?.length) {
        arrayOfCallbacks.forEach((callback) => callback(false));
      }
      if (res) {
        if (type !== null) {
          dispatch({ type, payload: res.body });
        }
        dispatch({ type: IS_LOADING, payload: false });
        if (cookie_option === "save") {
          const token = res.body.data.access_token;
          cookie.set("user_token", token);
        }
        if (res.body.reload) {
          window.location.reload();
        }
        if (res?.body?.message === "Unauthenticated.") {
          cookie.remove("user_token");
          cookie.remove("user_info");
          window.location.replace("/login");
        }
      } else {
        dispatch({ type: IS_LOADING, payload: false });
      }
    });
}

export function getRequestNotification(url, data, dispatch, type = null, cookie_option = null) {
  dispatch({ type: IS_LOADING, payload: true });
  return superagent
    .get(`${base_url}${url}`)
    .query(data)
    .set("accept", "application/json")
    .set("Authorization", cookie.get("user_token"))
    .end((err, res) => {
      if (res) {
        if (type !== null) {
          dispatch({ type, payload: res.body });
        }
        dispatch({ type: IS_LOADING, payload: false });
        if (cookie_option === "save") {
          const token = res.body.data.access_token;
          cookie.set("user_token", token);
        }
        if (res.body.reload) {
          window.location.reload();
        }
      } else {
        dispatch({ type: IS_LOADING, payload: false });
      }
    });
}

export function getDetailsRequest(url, slug, dispatch, type = null) {
  dispatch({ type: IS_LOADING, payload: true });
  return superagent
    .get(`${base_url}${url}/${slug}`)
    .set("accept", "application/json")
    .set("Authorization", cookie.get("user_token"))
    .end((err, res) => {
      if (res) {
        if (type !== null) {
          dispatch({ type, payload: res.body });
        }
        dispatch({ type: IS_LOADING, payload: false });
      } else {
        dispatch({ type: IS_LOADING, payload: false });
      }
    });
}

export async function getGroupList() {
  const response = await fetch(`${base_url}get-group-list`);
  const data = await response.json();
  return data.data.interests;
}

export const fetchCaptchaResponse = async (token) => {
  const url = `${base_url}not-robot`;
  const requestConfig = {
    method: "POST",
    body: JSON.stringify({ "g-recaptcha-response": token }),
    headers: {
      "Content-type": "application/json",
    },
  };
  try {
    const response = await fetch(url, requestConfig);
    const data = await response.json();
    return data;
  } catch (error) {
    return toast.error("Failed!");
  }
};

export const subscribeRequest = async (userData) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(userData),
  };
  try {
    const response = await fetch(`${base_url}subscribe-newsletter`, requestOptions);
    const data = await response.json();
    return data;
  } catch (error) {
    toast.error("Failed!");
  }
};
